import styled from '@emotion/styled';
import { Button } from '@mui/material';
import { Box, Tooltip, Typography } from '@kc-console/common-ui';
import { useScopedLinkBuilder } from '@kc-console/context';

import { getLnbItemButtonStyle } from '../styled';

interface Props {
  /**
   * List Item에 노출할 텍스트
   */
  label: string;

  /**
   * List Item 클릭 시 이동할 경로
   */
  path: string;

  /**
   * List Item 비활성화 여부
   * @default false
   */
  disabled?: boolean;

  /**
   * List Item 클릭 시 호출할 함수
   */
  onClick?: () => void;

  /**
   * List Item 좌측에 표기할 아이콘
   */
  startIcon?: React.ReactNode;

  /**
   * List Item 상단에 표기할 툴팁 메시지
   * @default ''
   */
  tooltipMessage?: string;
}

/**
 * @param props Props
 * @returns React.JSX.Element
 */
export default function RecentListItem({
  label,
  path,
  startIcon,
  tooltipMessage,
  onClick,
  ...others
}: Props) {
  const { getProps } = useScopedLinkBuilder();
  const linkProps = getProps(path, { onClick });

  return (
    <Tooltip message={tooltipMessage} placement={'right'}>
      <ItemButton LinkComponent="a" {...linkProps} disableRipple {...others}>
        {startIcon && <IconBox>{startIcon}</IconBox>}
        <Typography variant={'label/regular/sm'}>{label}</Typography>
      </ItemButton>
    </Tooltip>
  );
}

const IconBox = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 16px;
  color: ${({ theme }) => theme.color['icon/default']};
`;

// TODO: common-ui에서 LinkComponent props를 아직 제공하지 않고 있어서 mui 사용
const ItemButton = styled(Button)`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 6px;
  width: 100%;
  min-width: auto;
  height: 32px;
  padding: 0 20px;
  border-radius: 0;
  text-transform: none;
  text-align: left;
  color: ${({ theme }) => theme.color['text/weak/default']};

  ${({ theme }) => getLnbItemButtonStyle(theme)};
`;
